import {
  addUniqueValueToArray
} from 'utils/redux'

export const NAMESPACE = 'KanBo/Home/spUsers/'
export const SET_LOAD_STATUS = NAMESPACE + 'SET_LOAD_STATUS'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const REMOVE_ALL = NAMESPACE + 'REMOVE_ALL'
export const SET_USER = NAMESPACE + 'SET_USER'

const initialState = {
  users: [],
  usersByProfileKey: {},
  loading: false,
  loaded: false
}

export const userDefaults = {
  profileKey: '',
  name: '...',
  logins: [],
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case SET_LOAD_STATUS:
      return {
        ...state,
        loading: action.payload.loading,
        loaded: action.payload.loaded
      }
    case ADD: {
      const newState = {
        ...state,
        usersByProfileKey: { ...state.usersByProfileKey }
      }
      newState.users = addUniqueValueToArray({
        array: newState.users,
        value: action.payload.profileKey
      })
      newState.userGroupsById[action.payload.profileKey] = {
        ...userDefaults,
        ...action.payload
      }
      return newState
    }
    case ADD_ARRAY: {
      const newState = {
        ...state,
        users: [ ...state.users ],
        usersByProfileKey: { ...state.usersByProfileKey }
      }
      action.payload.forEach(user => {
        newState.users = addUniqueValueToArray({
          array: newState.users,
          value: user.profileKey
        })
        newState.usersByProfileKey[user.profileKey] = {
          ...userDefaults,
          ...user
        }
      })
      return newState
    }
    case REMOVE_ALL:
      return {
        ...state,
        users: [],
        usersByProfileKey: {}
      }
    case SET_USER:
      return {
        ...state,
        usersByProfileKey: {
          ...state.usersByProfileKey,
          [action.payload.profileKey]: {
            ...state.usersByProfileKey[action.payload.profileKey],
            ...action.payload.data
          }
        }
      }
    default: return state
  }
}

export function setLoadStatus ({ loading, loaded }) {
  return {
    type: SET_LOAD_STATUS,
    payload: {
      loading,
      loaded
    }
  }
}

export function add (data) {
  return {
    type: ADD,
    payload: data
  }
}

export function addArray (usersArray) {
  return {
    type: ADD_ARRAY,
    payload: usersArray
  }
}

export function removeAll () {
  return {
    type: REMOVE_ALL,
    payload: {}
  }
}

export function setUser ({ profileKey, ...data }) {
  return {
    type: SET_USER,
    payload: {
      profileKey,
      ...data
    }
  }
}
